import React from 'react';
import './Courses.css';

const Courses = () => {
  return (
    <div className="courses-container">
      <h1>Courses</h1>
      
      <h2>How to Use EarnStar</h2>
      <ul>
        <li>Download the EarnStar app on your mobile device.</li>
        <li>Create an account and log in.</li>
        <li>Browse the available games and choose one to play.</li>
        <li>Play the game for up to 6 hours a day to earn rewards.</li>
        <li><strong>Withdraw Your Earnings Daily:</strong> After each gaming session, withdraw your earnings through the app daily.</li>
      </ul>

      <h2>How to Make Payments to EarnGain</h2>
      <ul>
        <li>Go to the Payments page in your EarnGain dashboard.</li>
        <li>Click the "Make a Payment" button.</li>
        <li><strong>Send Your Weekly Payment Every Friday:</strong> Use the details on the Payments page to send your weekly payment every Friday.</li>
        <li>Confirm that you have sent the payment and enter the amount.</li>
        <li>Submit the form to record your payment.</li>
      </ul>

      <div className="video-container">
        <iframe 
          src="https://www.youtube.com/embed/GsecT8ezCGw" 
          title="YouTube video player" 
          frameBorder="0" 
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
          allowFullScreen>
        </iframe>
      </div>
    </div>
  );
};

export default Courses;
